// extracted by mini-css-extract-plugin
export var container = "_ez-0";
export var content = "_ez-3";
export var customerTitle = "_ez-4";
export var empty = "_ez-5";
export var gray = "_ez-6";
export var header = "_ez-7";
export var info = "_ez-8";
export var loading = "_ez-2";
export var loadingCard = "_ez-9";
export var oneLine = "_ez-a";
export var personName = "_ez-e";
export var pillContainer = "_ez-b";
export var selected = "_ez-1";
export var text = "_ez-c";
export var twoLines = "_ez-d";
export var unread = "_ez-f";
export var unreadIndicator = "_ez-g";